import React from 'react'
import '../style/people.css'
import work1 from '../images/people-1.jpg'
import work2 from '../images/people-2.jpg'
import work3 from '../images/people-3.jpg'

const People = () => {
    return (
        <>
            <section>
                <div className='container' style={{ marginTop: '50px', marginBottom: "50px", textAlign: 'center' }}>
                    <div className='cta-container'>
                        <div className='btnTalk' >
                            <a href="/ContactUs" target='_blank'>
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Achieve The Freedom For Which You Started The </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='container' style={{ marginTop: '50px' }}>
                    <h3 style={{ color: "#00415d", textAlign: 'center' }}>Expertise </h3>
                    <p style={{ marginTop: '25px', fontSize: '15px' }}>We specialize in laying the groundwork and crafting comprehensive people-centric growth strategies. From setting the foundation with Visioning, OKRs, KPIs, and RASICs to optimizing Performance Management and fostering employee engagement & retention, our expertise covers all bases.</p>
                </div>
                <div className='container' style={{ marginTop: '30px' }}>
                    <div className='row' style={{ marginTop: '50px', border: '1px solid #00415d', padding: '15px 5px 15px 5px', backgroundColor: '#00415d', color: 'white', borderRadius: "10px" }} id='rM'>
                        <div className='col'>
                            <img className='w-100 h-100' src={work1} alt="work" id='iM' />
                        </div>
                        <div className='col' id='colD' style={{ marginTop: '40px' }}>
                            <h4 style={{ color: 'white', marginLeft: '25px' }}>Organisation Growth Initiatives</h4>
                            <ul style={{ fontSize: '15px', marginLeft: '25px' }}>
                                <li>Organisation Growth Initiatives</li>
                                <li>Employee engagement & Retention.</li>
                                <li>Visioning, Organisation OKRs</li>
                                <li>KPIs, RASICs, Performance Management systems</li>
                                <li>Assessment - Baselining key leadership and personnel on key competencies, identifying scaleability improvement areas – using Assessment tools (Motivation Factor, MBTI, DISC, Leadership Style, etc.)</li>
                            </ul>
                            <div className='btnTalk' >
                                <a href="/ContactUs" target='_blank'>
                                    <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500', marginLeft: '25px' }} className="btn btn-primary btn-lg">Explore More
                                        <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '25px', flexDirection: 'row-reverse', border: '1px solid #f0f0f0', padding: '15px 5px 15px 5px', backgroundColor: '#f0f0f0', color: 'black', borderRadius: "10px" }} id='rM'>
                        <div className='col' >
                            <img className='w-100 h-100' src={work2} alt="work" />
                        </div>
                        <div className='col' id='rmarg' style={{ marginTop: '40px' }}>
                            <h3 style={{ color: '#00415d' }}>Coaching / Mentoring</h3>
                            <p style={{ fontSize: '15px' }}>Executive, Business, Sales, Life Coaching for Corporate Leaders, mid-management, SMB promoters, Entrepreneurs Family Businesses</p>
                            <ul style={{ fontSize: '15px' }}>
                                <li>Individual-focused - linked to organisation objectives</li>
                                <li>Team / Buddy Mentoring – to improve step-up, scale-up based on factors identified during initial Assessment</li>
                            </ul>
                            <div className='btnTalk' >
                                <a href="/ContactUs" target='_blank'>
                                    <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                        <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '25px', border: '1px solid #00415d', padding: '15px 5px 10px 0px', backgroundColor: '#00415d', color: 'white', borderRadius: "10px" }} id='rM'>
                        <div className='col'>
                            <img className='w-100 h-100' src={work3} alt="work" id='iM' />
                        </div>
                        <div className='col' id='colD' style={{ marginTop: '10px' }}>
                            <h3 style={{ color: 'white', marginLeft: '25px' }}>Competency Development</h3>
                            <p style={{ fontSize: '15px', marginLeft: '25px' }}>Workshops (Physical and Virtual) – Tailored for senior and mid-management, our workshops focus on essential topics such as Sustainable Leadership, Teaming, Change Management, Culture, and Decision Making. We use a multi-faceted approach to foster development:</p>
                            <ul style={{ fontSize: '15px', marginLeft: '25px' }}>
                                <li>Tools / Models: Utilizing proven frameworks and methodologies.</li>
                                <li>Case Studies: Analyzing real-world scenarios to draw practical insights.</li>
                                <li>Videos / Movies: Leveraging visual media to illustrate key concepts.</li>
                                <li>Learning by Doing: Engaging in action learning, on-the-job observation, feedback sessions, and assignments.</li>
                                <li>Learning from Others: Encouraging experience sharing and role plays to benefit from peer insights.</li>
                                <li>Self Discovery / Reflection: Promoting personal growth through self-assessment and reflective practices.</li>
                            </ul>
                            <div className='btnTalk' >
                                <a href="/ContactUs" target='_blank'>
                                    <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500', marginLeft: '25px' }} className="btn btn-primary btn-lg">Explore More
                                        <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default People
